import { Navigate } from "react-router-dom";
import { AppShell } from "../components/dashboard/app-shell";
import TaskPageNew from "./TaskPageNew";
import { useUser } from "contexts/UserContext";

export default function TaskPageWrapper() {
  const { user, loading, setUser } = useUser();

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[var(--hexa-bg-gradient-start)] via-[var(--hexa-bg-gradient-mid)] to-[var(--hexa-bg-gradient-end)] flex items-center justify-center">
        <div className="text-[var(--hexa-text-primary)] text-lg">Caricamento...</div>
      </div>
    );
  }

  // Se non c'è utente e non c'è token, reindirizza al login
  if (!user && !localStorage.getItem("accessToken")) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AppShell currentUser={user} onUserUpdate={setUser}>
      <TaskPageNew />
    </AppShell>
  );
}
